export const toFormData = <T extends object>(payload: T): FormData => {
	const formData = new FormData();

	Object.entries(payload).forEach(([key, value]) => {
		if (value === undefined || value === null) return;

		if (typeof value === "boolean" || typeof value === "number") {
			formData.append(key, value.toString());
			return;
		}

		if (value instanceof File) {
			formData.append(key, value);
			return;
		} else if (Array.isArray(value) && value.every((v) => v instanceof File)) {
			value.forEach((file) => formData.append(key, file));
			return;
		}

		formData.append(key, value.toString());
	});

	return formData;
};

export const valueOrFallback = (value: unknown, fallback: string = "-"): string => {
	if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
		return fallback;
	}

	return String(value);
};
